import React from 'react';
import { Box, Flex, Skeleton, Text } from '@mantine/core';
import { useRelatedProductFeatures } from '../../../hooks/explore/useRelatedProductFeatures';
import { RelatedIdeaCard } from './RelatedIdeaCard';

export interface RelatedProductFeaturesSectionProps {
  evidenceIds: string[];
}

export const RelatedProductFeaturesSection: React.FC<RelatedProductFeaturesSectionProps> = ({
  evidenceIds,
}) => {
  const { ideas, isLoading } = useRelatedProductFeatures(evidenceIds);

  if (evidenceIds.length === 0) {
    return null;
  }

  return (
    <Box sx={{ minWidth: 0, maxWidth: '100%', width: '100%', overflow: 'hidden' }}>
      <Flex px="md" align="center" justify="space-between" mb="md">
        <Text fw={500} c="#212529" sx={{ fontSize: 16, lineHeight: 1.3, maxWidth: '85%' }}>
          Related Ideas and Features
        </Text>

      </Flex>

      {isLoading ? (
        <Box sx={{ overflowX: 'auto', maxWidth: '100%', minWidth: 0 }}>
          <Flex  px="md" gap="md" sx={{ flexWrap: 'nowrap', width: 'max-content' }}>
            {[1, 2, 3].map((i) => (
              <Skeleton key={i} height={182} width={288} radius="md" sx={{ flexShrink: 0 }} />
            ))}
          </Flex>
        </Box>
      ) : ideas.length === 0 ? (
        <Text px="md" size="sm" c="dimmed">
          These evidences are not matched or assigned to any idea or feature yet.
        </Text>
      ) : (
        <Box
          px="md"
          sx={{
            overflowX: 'auto',
            overflowY: 'hidden',
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            paddingBottom: 4,
            WebkitOverflowScrolling: 'touch',
          }}
        >
          <Flex gap="md" align="stretch" sx={{ flexWrap: 'nowrap', width: 'max-content' }}>
            {ideas.map((idea) => (
              <RelatedIdeaCard key={idea._id} idea={idea} />
            ))}
          </Flex>
        </Box>
      )}
    </Box>
  );
};

export default RelatedProductFeaturesSection;
